import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class DownSettingModal extends Vue {
  @Prop() visible: Boolean = false
  textarea = ''

  handleOk(){
    const str= this.textarea.replace(/[\r\n]/g,',')
    console.log(str)
    this.textarea = ''
    this.$emit('cancel')
  }
  handleCancel(){
    this.textarea = ''
    this.$emit('cancel')
  }
  changeText(e){
    this.textarea = e.target.value
  }

  render() {
    return (
      <a-modal
        title={this.$t('page_bill_settings_set_drapdown')}
        visible={this.visible}
        onOk={() => this.handleOk()}
        maskClosable={false}
        onCancel={() => this.handleCancel()}
      >
        <a-alert message={this.$t('page_bill_settings_set_drapdown_value')} type="info" showIcon />
        <a-textarea onChange={e => this.changeText(e)} rows={14} style="margin-top: 16px;" />
      </a-modal>
    )
  }
}